module.exports = __webpack_public_path__ + "static/media/male-avatar.72b7182a.png";